import { Select, Spin } from 'antd';
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { api, endpoint } from '../../api';

const initData = {
    title: '',
    parameter: "",
    min: '',
    max: '',
    unit: ''
}

const DialForm = ({ mode = 'create', data }) => {
    const navigate = useNavigate()


    const [formData, setFormData] = useState(initData)
    const [isLoading, setIsLoading] = useState(false)
    const [parameters, setParameters] = useState([])
    const [successMessage, setSuccessMessage] = useState('')
    const [errorMessage, setErrorMessage] = useState('')
    const [devices, setDevices] = useState([])



    const { title, parameter, min, max, unit, device } = formData

    // get device
    const getDevice = async () => {
        const response = await api.get(`/device`, {
            withCredentials: true,
            // params: { site: locationId },
        });
        if (response.results.length > 0) {
            console.log({ response })
            setDevices(response?.results);
        }
    }

    // get system parameter
    const getSystemParameters = async (id) => {
        setIsLoading(true);
        try {
            setParameters([])
            const { results } = await api.get(endpoint.get_device_parameter, {
                params: {
                    deviceId: id,
                    limit: 1000,
                    page: 1,
                    sortBy: 'name',
                    orderBy: 'ASC',
                    type: 'formula',
                },
            });
            console.log({ results })
            setParameters(results);
        } catch (error) { }
        setIsLoading(false);
    };

    useEffect(() => {
        if (device) {
            getSystemParameters(device)
        }
    }, [device])


    useEffect(() => {
        getDevice()
    }, [])
    useEffect(() => {
        if (mode === 'update' && Object.keys(data).length > 0) {
            setFormData(data)
        }
    }, [mode])


    const handleChange = e => {
        setFormData({ ...formData, [e.target.name]: e.target.value })
    }

    const handleParameterChange = (value, option) => {
        // console.log({ value, option })
        setFormData({ ...formData, parameter: value })
    }

    const handleDeviceChange = (value, option) => {
        setFormData({ ...formData, device: value })
        // getSystemParameters(value)
    }


    // edit handler
    const handleSubmit = async e => {
        e.preventDefault()
        setIsLoading(true)
        try {
            const { results, success, message } = await api.post(endpoint.create_dial, formData)
            if (success) {
                setSuccessMessage('Dial Created Successfully')
            } else {
                setErrorMessage(message)
            }
        } catch (error) {
            setErrorMessage(error.message || 'Some Error Occurred')
        }
        setIsLoading(false)
        setTimeout(() => {
            setErrorMessage('');
            setSuccessMessage('')
            navigate('/dial')
        }, 2000);
    }

    // submit handler
    const handleEdit = async e => {
        e.preventDefault()
        setIsLoading(true)
        try {
            const { results, success, message } = await api.put(endpoint.dial + '/' + data._id, formData)
            if (success) {
                setSuccessMessage('Dial Updated Successfully')
            } else {
                setErrorMessage(message)
            }
        } catch (error) {
            setErrorMessage(error.message || 'Some Error Occurred')
        }
        setIsLoading(false)
        setTimeout(() => {
            setErrorMessage('');
            setSuccessMessage('')
            navigate('/dial')
        }, 2000);
    }

    return (
        <Spin spinning={isLoading}>
            <div className="card p-3 m-3">

                {errorMessage && (
                    <div className="alert alert-danger" role="alert">
                        {errorMessage}{" "}
                    </div>
                )}

                {successMessage && (
                    <div className="alert alert-success" role="alert">
                        {successMessage}{" "}
                    </div>
                )}


                <div className="d-flex align-items-center justify-content-between">
                    <div>
                        <label className="az-content-label">Manage Dial</label>
                        <span className="d-block py-2 text-capitalize">{mode} Dial</span>
                    </div>
                </div>

                <form onSubmit={mode === 'create' ? handleSubmit : handleEdit} className='row my-4 gy-3'>
                    <div className="col-md-6">
                        <label htmlFor="title" className="form-label">
                            Dial Title
                            <span className="text-danger" style={{ fontFamily: 'monospace', marginLeft: 3 }}>
                                *
                            </span>
                        </label>
                        <input
                            onChange={handleChange}
                            type="text"
                            className='form-control'
                            placeholder='Dial Title'
                            name="title"
                            id="title"
                            required
                            value={title}
                        />
                    </div>

                    <div className="col-md-6">
                        <label htmlFor="title" className="form-label">
                            Select Device
                            <span className="text-danger" style={{ fontFamily: 'monospace', marginLeft: 3 }}>
                                *
                            </span>
                        </label>
                        <Select
                            style={{ width: '100%', color: 'red' }}
                            size="large"
                            id="device"
                            name="device"
                            value={device}
                            onChange={handleDeviceChange}
                            placeholder="Select device"
                            options={[...devices.map((item) => ({ label: item.name, value: item._id }))]}
                            required
                        />
                    </div>

                    <div className="col-md-6">
                        <label htmlFor="title" className="form-label">
                            Select Parameter
                            <span className="text-danger" style={{ fontFamily: 'monospace', marginLeft: 3 }}>
                                *
                            </span>
                        </label>
                        <Select
                            style={{ width: '100%', color: 'red' }}
                            size="large"
                            id="parameter"
                            name="parameter"
                            value={parameter}
                            onChange={handleParameterChange}
                            placeholder="Select device type"
                            options={[...parameters.map((item) => ({ label: item.name, value: item._id }))]}
                            required
                        />
                    </div>

                    <div className="col-md-6">
                        <label htmlFor="min" className="form-label">
                            Min
                            <span className="text-danger" style={{ fontFamily: 'monospace', marginLeft: 3 }}>
                                *
                            </span>
                        </label>
                        <input
                            onChange={handleChange}
                            type="number"
                            className='form-control'
                            placeholder='Min'
                            name="min"
                            id="min"
                            required
                            value={min}
                        />
                    </div>

                    <div className="col-md-6">
                        <label htmlFor="Max" className="form-label">
                            Max
                            <span className="text-danger" style={{ fontFamily: 'monospace', marginLeft: 3 }}>
                                *
                            </span>
                        </label>
                        <input
                            onChange={handleChange}
                            type="Number"
                            placeholder='max'
                            className='form-control'
                            name="max"
                            id="max"
                            required
                            value={max}
                        />
                    </div>

                    <div className="col-md-6">
                        <label htmlFor="unit" className="form-label">
                            Unit
                            <span className="text-danger" style={{ fontFamily: 'monospace', marginLeft: 3 }}>
                                *
                            </span>
                        </label>
                        <input
                            onChange={handleChange}
                            type="text"
                            className='form-control'
                            placeholder='Unit'
                            name="unit"
                            id="unit"
                            required
                            value={unit}
                        />
                    </div>

                    <div className="d-flex">
                        <button type='submit' className="btn btn-success ms-auto"> {mode === 'create' ? 'Add a Dial' : 'Update Dial'} </button>
                        <button type='submit' onClick={() => navigate(-1)} className="btn btn-secondary ms-2"> Cancel </button>
                    </div>
                </form>

            </div>
        </Spin>
    );
};

export default DialForm;